import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TableList } from 'seagull';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { useProposalRowItems } from '~/pages/ProposalsDashboard/proposalRowItems';
import { selectors } from '~/store/state-selectors';
const COLUMN_DEFS = [
    {
        width: [
            200,
            320
        ]
    },
    {
        width: [
            90,
            110
        ]
    },
    {
        width: [
            120,
            160
        ]
    },
    {
        width: [
            150,
            190
        ]
    }
];
const SentProposalRow = (param)=>{
    let { proposal, isVendor, index, testId } = param;
    return /*#__PURE__*/ _jsx(TableList.Row, {
        rowId: proposal.id,
        testId: testId,
        items: useProposalRowItems(proposal, isVendor, index)
    });
};
export const SentProposalsTable = (param)=>{
    let { proposals, testId } = param;
    const { t: proposalsTexts } = useLocaleKeys('proposal.dashboard');
    const isVendor = useStore(selectors.user.isVendor);
    const headerItems = useMemo(()=>[
            {
                value: proposalsTexts.columnHeaders.companyName()
            },
            {
                value: proposalsTexts.columnHeaders.sentDate()
            },
            {
                value: proposalsTexts.columnHeaders.sentBy()
            },
            {
                value: proposalsTexts.columnHeaders.status()
            }
        ], []);
    return /*#__PURE__*/ _jsxs(TableList.Provider, {
        columnDefs: COLUMN_DEFS,
        numRows: proposals.length,
        children: [
            /*#__PURE__*/ _jsx(TableList.Header, {
                items: headerItems,
                testId: "".concat(testId, "-header")
            }),
            proposals.map((proposal, index)=>/*#__PURE__*/ _jsx(SentProposalRow, {
                    proposal: proposal,
                    isVendor: isVendor,
                    index: index,
                    testId: "".concat(testId, "-row-").concat(index)
                }, proposal.id))
        ]
    });
};
